import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  ParamMap,
  Router,
} from "@angular/router";
import { Location } from "@angular/common";
import { Subject, Subscription, forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";
import { EmitterService } from "src/app/EmitterService";
import { Navbar } from "../navbar/navbar.component";

@Component({
  selector: "app-aside",
  templateUrl: "./aside.component.html",
  styleUrls: ["./aside.component.scss"],
})
export class AsideComponent {
  imageLoaded = false;
  current_main_route: any;
  fetchinData = true;
  subscription: Subscription;
  mainData: any;
  currentRoute: string;
  currentMenuItem: any;
  ContentData: any[] = [];
  allSubmenuItems: any;
  cuurent_menu_parent_name: any;
  currentContentData: any;
  private ngUnsubscribe = new Subject();
  @ViewChild(Navbar)
  childComponent: Navbar;
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private appService: AppService,
    private router: Router,
    private emitterService: EmitterService
  ) {}
  ngOnInit() {
    this.FetchData();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
    // this.subscription.unsubscribe();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  FetchData() {
    // debugger;
    let mData = localStorage.getItem("mainData");

    if (mData != null) {
      this.mainData = JSON.parse(mData);
      this.currentRoute = "/" + this.route.snapshot.url.join("/");
      this.current_main_route = this.route.snapshot.url.join("/");

      let currentMenu = this.mainData.SiteMapList.filter(
        (item) => item.MenuUrl == this.currentRoute
      );
      // All menu names
      if (currentMenu.length > 0) {
        let parentId = currentMenu[0].ParentId;

        // Filter SiteMapList to get all menu names with the same ParentId
        let filteredMenus = this.mainData.SiteMapList.filter(
          (item) => item.ParentId == parentId
        );

        // Extract MenuNames and MenuUrls from filteredMenus
        let menuDetails = filteredMenus.map((item) => {
          return {
            MenuName: item.MenuName,
            MenuUrl: item.MenuUrl,
          };
        });
        this.allSubmenuItems = menuDetails;
        console.log(menuDetails,"All aside items");
      } else {
        console.log("Current menu not found.");
      }
      // All menu names ends

      this.cuurent_menu_parent_name = currentMenu[0];

      console.log(this.cuurent_menu_parent_name, "Current Menu");
      if (currentMenu.length != 0) {
        this.currentMenuItem = currentMenu[0];
      }

      // this.emitterService.changeMessage(false);
    }
  }
}
